"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _jsxRuntime = require("react/jsx-runtime");
var _react = _interopRequireWildcard(require("react"));
var _modal = require("./modal.style");
var _Box = _interopRequireDefault(require("../Box"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
const Modal = /*#__PURE__*/(0, _react.forwardRef)((props, ref) => {
  const {
      className = 'modal',
      heading,
      children,
      actions,
      open = false,
      backdropcloseactiondisabled = false,
      onClose,
      dimension = 'medium',
      zindex = 999,
      showCloseIcon = true
    } = props,
    restProps = __rest(props, ["className", "heading", "children", "actions", "open", "backdropcloseactiondisabled", "onClose", "dimension", "zindex", "showCloseIcon"]);
  const onBackDropClick = e => {
    const target = e.target;
    if (!backdropcloseactiondisabled && target.classList.contains('modal-backdrop') && onClose) {
      onClose();
    }
  };
  const [isEscEventAdded, setisEscEventAdded] = (0, _react.useState)(false);
  const escFunction = (0, _react.useCallback)(event => {
    if (event.keyCode === 27 && onClose) {
      onClose();
    }
  }, [onClose]);
  (0, _react.useEffect)(() => {
    if (open) {
      document.documentElement.style.overflow = 'hidden';
      if (!isEscEventAdded) {
        document.addEventListener('keydown', e => {
          escFunction(e);
        }, false);
        setisEscEventAdded(true);
      }
    }
    return () => {
      document.documentElement.style.overflow = 'unset';
      document.removeEventListener('keydown', e => {
        escFunction(e);
      }, false);
    };
  }, [open, escFunction]);
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: open && (0, _jsxRuntime.jsx)(_modal.Components.Wrapper, (0, _extends2["default"])({
      className: "".concat(className, " modal-backdrop"),
      zindex: zindex,
      onClick: e => onBackDropClick(e)
    }, {
      children: (0, _jsxRuntime.jsxs)(_modal.Components.Modal, (0, _extends2["default"])({
        dimension: dimension,
        open: open,
        zindex: zindex,
        ref: ref
      }, restProps, {
        children: [heading && (
        // Generate custom heading if node is passed
        /*#__PURE__*/_react["default"].isValidElement(heading) ? heading : (0, _jsxRuntime.jsx)(_modal.Components.Heading, (0, _extends2["default"])({
          dimension: dimension
        }, {
          children: heading
        }))), showCloseIcon && (0, _jsxRuntime.jsx)(_modal.Components.CloseIcon, {
          name: "times",
          size: "24",
          onClick: () => typeof onClose === 'function' ? onClose() : {}
        }), (0, _jsxRuntime.jsx)(_modal.Components.Body, (0, _extends2["default"])({
          hasFooter: !!actions,
          hasHeader: !!heading,
          dimension: dimension
        }, {
          children: children
        })), actions && (0, _jsxRuntime.jsxs)(_modal.Components.Footer, (0, _extends2["default"])({
          dimension: dimension,
          justifyContent: actions === null || actions === void 0 ? void 0 : actions.justifyContent,
          tertiaryActionPresent: (actions === null || actions === void 0 ? void 0 : actions.tertiaryAction) ? true : false
        }, {
          children: [actions === null || actions === void 0 ? void 0 : actions.tertiaryAction, (0, _jsxRuntime.jsxs)(_Box["default"], (0, _extends2["default"])({
            display: "flex"
          }, {
            children: [actions === null || actions === void 0 ? void 0 : actions.secondaryAction, actions === null || actions === void 0 ? void 0 : actions.primaryAction]
          }))]
        }))]
      }))
    }))
  });
});
var _default = exports["default"] = Modal;